/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./formattingOptions.vue?vue&type=template&id=00bc53fd&scoped=true&"
import script from "./formattingOptions.vue?vue&type=script&lang=js&"
export * from "./formattingOptions.vue?vue&type=script&lang=js&"
import style0 from "./formattingOptions.vue?vue&type=style&index=0&id=00bc53fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc53fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VDataTable,VIcon,VRow,VSwitch,VTextField,VTooltip})
